import React from 'react';
import styled from 'styled-components';
import Subject from '../../Components/Subject';
import EtcHeader from './EtcHeader';

const Container = styled.div`
  width: 1200px;
  margin: 0 auto;
  @media (max-width: 1280px) {
    width: 100%;
    padding: 0 20px 50px 20px;
  }
`;

const Box = styled.div`
  width: 100%;
  padding: 60px 20px;
  @media (max-width: 1080px) {
    padding: 40px 10px;
  }
  @media (max-width: 768px) {
    padding: 20px 5px;
  }
`;

const Title = styled.h1`
  font-size: 20px;
  padding: 15px 0;
  @media (max-width: 1080px) {
    font-size: 18px;
    padding: 12px 0;
  }
  @media (max-width: 768px) {
    font-size: 16px;
    padding: 10px 0;
  }
  @media (max-width: 480px) {
    font-size: 14px;
    padding: 8px 0;
  }
`;

const Desc = styled.textarea`
  padding: 10px;
  width: 100%;
  height: 1000px;
  font-weight: 300;
  color: #5d5d5d;
  font-family: 'Noto Sans KR', sans-serif;
`;

const Privacy = () => {
  const info = { title: '개인정보처리방침', path: '/user/privacy' };
  return (
    <>
      <EtcHeader />

      <Container>
        <Subject info={info} />
        <Box>
          <Title>개인정보처리방침</Title>
          <Desc
            placeholder={`미소테크(이하 '회사')는 개인정보보호법 등 관련 법령을 준수하며, 이용자의 개인정보 보호를 중요하게 생각합니다.

제1조 (개인정보의 처리 목적 및 수집 항목)

회사는 본 웹사이트(www.misotech7.com)를 통해 이용자의 개인정보를 수집하지 않습니다.
회원가입, 온라인 상담, 견적 요청 등 개인정보를 입력받는 기능을 운영하지 않으며, 별도의 회원제 서비스를 제공하지 않습니다.

제품 문의 등으로 이용자가 자발적으로 전자우편 또는 유선으로 연락하신 경우, 해당 문의 처리를 위한 목적으로만 연락처 정보를 이용하며 문의 처리 완료 후 지체 없이 파기합니다.

제2조 (개인정보의 제3자 제공)

회사는 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만 법령에 따라 수사기관 등이 적법한 절차에 따라 요구하는 경우에는 예외로 합니다.

제3조 (개인정보 처리의 위탁)

회사는 본 웹사이트 운영과 관련하여 개인정보 처리 업무를 위탁하지 않습니다.

제4조 (개인정보의 파기)

문의 처리 과정에서 취득한 연락처 등은 처리 목적이 달성되면 지체 없이 파기합니다. 전자적 파일은 복구할 수 없는 기술적 방법으로 삭제하고, 출력물은 분쇄하거나 소각합니다.

제5조 (자동 수집 장치의 설치·운영 및 거부)

본 웹사이트는 이용자의 정보를 저장하거나 수시로 불러오는 쿠키(cookie)를 운영하지 않습니다.
다만 오시는 길 안내를 위해 구글 지도를, 홍보 영상 제공을 위해 유튜브를 페이지에 삽입하고 있으며, 해당 서비스 이용 과정에서 각 사업자가 쿠키를 설치할 수 있습니다. 이는 각 사업자의 개인정보처리방침을 따릅니다.
쿠키 설치를 원하지 않으시는 경우 웹 브라우저 설정에서 이를 거부하실 수 있습니다.

제6조 (정보주체의 권리와 행사 방법)

이용자는 언제든지 회사가 보유한 자신의 개인정보에 대하여 열람, 정정, 삭제, 처리정지를 요구할 수 있습니다. 아래 개인정보 보호책임자에게 서면 또는 전자우편으로 연락하시면 지체 없이 조치하겠습니다.

제7조 (개인정보의 안전성 확보 조치)

회사는 개인정보의 안전한 처리를 위하여 개인정보 취급 담당자를 최소한으로 제한하고, 정기적인 교육을 실시하며, 개인정보를 보관하는 자료에 대한 접근을 통제하고 있습니다.

제8조 (개인정보 보호책임자)

회사는 개인정보 처리에 관한 업무를 총괄하여 책임지고, 개인정보 처리와 관련한 이용자의 불만 및 피해 구제를 처리하기 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.

· 개인정보 보호책임자 : 임지혁 과장
· 연락처 : 010-3848-1043 (대표번호 031-594-1042)
· 전자우편 : misotech7@naver.com

제9조 (권익침해 구제 방법)

개인정보 침해로 인한 상담 및 피해 구제가 필요하신 경우 아래 기관에 문의하실 수 있습니다.

· 개인정보침해 신고센터 (privacy.kisa.or.kr / 국번없이 118)
· 개인정보 분쟁조정위원회 (kopico.go.kr / 1833-6972)
· 대검찰청 사이버수사과 (spo.go.kr / 국번없이 1301)
· 경찰청 사이버수사국 (ecrm.police.go.kr / 국번없이 182)

제10조 (개인정보처리방침의 변경)

본 방침은 2026년 9월 11일부터 적용됩니다.
법령 및 방침에 따른 변경 내용의 추가, 삭제 및 정정이 있는 경우에는 변경 사항의 시행 7일 전부터 웹사이트 공지사항을 통하여 고지할 것입니다.
  `}></Desc>
        </Box>
      </Container>
    </>
  );
};

export default Privacy;
